import api from "./api-config";
import { ContactDTO } from "../models/Contact";
import { PatientFormDTO } from "../models/PatientForm";

export const contactService = {
  sendContact: async (payload: ContactDTO) => {
    const response = await api.post<void>("/contact", payload);
    return response.data;
  },
  patientContact: async (payload: PatientFormDTO) => {
    const response = await api.post<void>("/patientContact", payload);
    return response.data;
  },
};
